import { useContext, useState } from "react";
import { GlobalProvider } from "../Context/GlobalState";
import { GlobalContext } from "../Context/GlobalState";

import axios from "axios";

export default function MunavebeKayit() {

    const {
      urunler,
      API_URL,
      munavebeler,
      setMunavebeler,
    } = useContext(GlobalContext);

  const kullaniciAdi = window.localStorage.getItem("user");

  const [munavebeAdi, setMunavebeAdi] = useState("");
  const [munavebeTablosu, setMunavebeTablosu] = useState([{}]);

  const handleServiceChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...munavebeTablosu];
    list[index][name] = value;
    setMunavebeTablosu(list);
    console.log("list :>> ", list);
  };

  const handleServiceRemove = (index) => {
    const list = [...munavebeTablosu];
    list.splice(index, 1);
    setMunavebeTablosu(list);
  };

  const handleServiceAdd = () => {
    setMunavebeTablosu([...munavebeTablosu, {}]);
  };

  const munavebeAdiAl = (e) => {
    const ad = e.target.value;
    setMunavebeAdi(ad);
  };

  function checkUrunAdi(objArray) {
    return objArray.every((obj) => obj.hasOwnProperty("urunAdi"));
  }

  const munavebeyiDbyeKaydet = (e) => {
    e.preventDefault();
    console.log(munavebeTablosu);

    if (checkUrunAdi(munavebeTablosu)) {
      axios
        .post(API_URL + "/munavebekaydet", {
          kullaniciAdi,
          munavebeAdi,
          munavebeTablosu,
        })
        .then((response) => {
          console.log('response :>> ', response);
          alert(response.data);
          //window.location.reload();
        })
        .catch((error) => {
          alert("Aynı İsimde Münavebe Kaydedilemez!");
          console.error("There was an error!", error);
        });
    } else {
      alert("Ürün Adı Boş Olamaz!");
    }
  };

  const munavebeSil = async (id) => {
    if (!window.confirm("Bu münavebe silinsin mi?")) return;

    try {
      await axios.delete(`${API_URL}/munavebe/${id}`);

      setMunavebeler((prev) => prev.filter((item) => item.id !== id));

      alert("Münavebe silindi.");
    } catch (err) {
      console.log(err.data);
      alert("Silinemedi.");
    }
  };

  return (
    <GlobalProvider>
      <div className="container">
        <div className="row">
          <h1 className="text-center">Münavebe ve Değerleme </h1>
        </div>
        <div className="row my-2">
          <h3>Münavebe Ürünleri</h3>
        </div>
        <form onSubmit={munavebeyiDbyeKaydet}>
          <div className="row my-2">
            <div className="col-3">
              <input
                type="text"
                name="munavebeAdi"
                id="munavebeAdi"
                placeholder="Munavebe Adını Giriniz"
                className="form-control"
                onChange={(e) => munavebeAdiAl(e)}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="col mt-1 mb-2 mx-2">
              <div className="row mt-3">
                <div className="col">Ürün Adı</div>
                <div className="col">Ürün Verimi</div>
                <div className="col">Ürün Fiyatı</div>
                <div className="col">Yan Ürün Geliri</div>
                <div className="col">Masraf</div>
                <div className="col"></div>
              </div>
              {munavebeTablosu.map((urun, index) => (
                <div
                  key={index}
                  className="row border border-primary rounded mt-2"
                >
                  <div className="col my-1">
                    <div className="input-group">
                      <span className="input-group-text bg-primary">
                        {index + 1}
                      </span>

                      <select
                        name="urunAdi"
                        onChange={(e) => handleServiceChange(e, index)}
                        className="form-control"
                        required
                      >
                        <option>--Ürün Seçiniz--</option>
                        {urunler.map((urun, index) => (
                          <option key={index}>{urun}</option>
                        ))}
                      </select>
                      <input
                        placeholder="Ürün Verimi"
                        name="anaUrunVerim"
                        type="number"
                        step={"0.01"}
                        id="anaUrunVerim"
                        className="form-control mx-2"
                        onChange={(e) => handleServiceChange(e, index)}
                        required
                      />
                      <input
                        placeholder="Ürün Fiyatı"
                        name="anaUrunFiyat"
                        type="number"
                        step={"0.01"}
                        id="anaUrunFiyat"
                        className="form-control mx-2"
                        onChange={(e) => handleServiceChange(e, index)}
                        required
                      />
                      <input
                        placeholder="Yan Ürün Geliri"
                        name="yanUrunGelir"
                        type="number"
                        step={"0.01"}
                        id="yanUrunGelir"
                        className="form-control mx-2"
                        onChange={(e) => handleServiceChange(e, index)}
                        required
                      />

                      <input
                        placeholder="Masraf"
                        name="masraf"
                        type="number"
                        step={"0.01"}
                        id="masraf"
                        className="form-control mx-2"
                        onChange={(e) => handleServiceChange(e, index)}
                        required
                      />

                      {munavebeTablosu.length - 1 === index &&
                        munavebeTablosu.length < 4 && (
                          <button
                            type="button"
                            onClick={handleServiceAdd}
                            className="btn btn-primary"
                          >
                            <span>Ürün Ekle</span>
                          </button>
                        )}
                    </div>
                  </div>
                  <div className="col-2 my-1">
                    {munavebeTablosu.length !== 1 && (
                      <button
                        type="button"
                        onClick={() => handleServiceRemove(index)}
                        className="btn btn-danger"
                      >
                        <span>Sil</span>
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="row">
            <div className="col"></div>
            <div className="col"></div>
            <div className="col"></div>
            <div className="col">
              <button type="submit" className="btn btn-primary btn-lg mt-5">
                Münavebe Kaydet
              </button>
            </div>
          </div>
        </form>

        <hr className="my-5" />

        <h3>Kayıtlı Münavebeler</h3>

        <table className="table table-striped table-hover">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Münavebe Adı</th>
              <th>İşlem</th>
            </tr>
          </thead>

          <tbody>
            {munavebeler.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.name}</td>

                <td width="120">
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => munavebeSil(item.id)}
                  >
                    Sil
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </GlobalProvider>
  );
}
